import {
  GET_CASHBOOK_HEAD_LIST,
  GET_CASHBOOK_HEAD_LIST_SUCCESS,
  SAVE_CASHBOOK_HEAD,
  SAVE_CASHBOOK_HEAD_SUCCESS,
  EDIT_CASHBOOK_HEAD_ID,
  EDIT_CASHBOOK_HEAD_ID_SUCCESS,
  UPDATE_CASHBOOK_HEAD_ID,
  UPDATE_CASHBOOK_HEAD_ID_SUCCESS,
  DELETE_CASHBOOK_HEAD_ID,
  DELETE_CASHBOOK_HEAD_ID_SUCCESS,
  CASHBOOK_HEAD_API_ERROR_ACTION,
} from "./actionTypes";

export const getCashBookHeadList = (source = "master") => ({ // get List Action
  type: GET_CASHBOOK_HEAD_LIST,
  payload: source,
});

export const getCashBookHeadListSuccess = (data) => ({ // get List Success
  type: GET_CASHBOOK_HEAD_LIST_SUCCESS,
  payload: data,
});

export const saveCashBookHead = (config = {}) => ({ // save Action
  type: SAVE_CASHBOOK_HEAD,
  config,
});

export const saveCashBookHeadSuccess = (resp) => ({ // save Success
  type: SAVE_CASHBOOK_HEAD_SUCCESS,
  payload: resp,
});

export const editCashBookHeadID = (config = {}) => ({ // edit Action
  type: EDIT_CASHBOOK_HEAD_ID,
  config,
});

export const editCashBookHeadIDSuccess = (editData) => ({ // edit Success
  type: EDIT_CASHBOOK_HEAD_ID_SUCCESS,
  payload: editData,
});

export const updateCashBookHeadID = (config = {}) => ({ // update Action
  type: UPDATE_CASHBOOK_HEAD_ID,
  config,
});

export const updateCashBookHeadIDSuccess = (resp) => ({ // update Success
  type: UPDATE_CASHBOOK_HEAD_ID_SUCCESS,
  payload: resp,
});

export const deleteCashBookHeadID = (config = {}) => ({ // delete Action
  type: DELETE_CASHBOOK_HEAD_ID,
  config,
});

export const deleteCashBookHeadIDSuccess = (resp) => ({ // delete Success
  type: DELETE_CASHBOOK_HEAD_ID_SUCCESS,
  payload: resp,
});

export const cashBookHeadApiErrorAction = () => ({
  type: CASHBOOK_HEAD_API_ERROR_ACTION,
});